import cn from 'classnames'
import * as React from 'react'
import { Tooltip } from '../../atoms/Tooltip'
import styles from './Table.module.scss'

export type CellProps = React.ComponentPropsWithoutRef<'td'> & {
  /**
   * Whether content should be right aligned, default is false
   */
  right?: boolean
  /**
   * Whether or not to show grey muted text
   */
  muted?: boolean
}

export const Cell = (props: CellProps) => {
  const { children, className, right, muted, ...restProps } = props

  const [isOverflowed, setIsOverflowed] = React.useState(false)
  const textElementRef = React.useRef<HTMLTableCellElement | null>(null)
  const childIsString = typeof children === 'string'
  const cellClassName = cn(
    styles.cell,
    muted && styles.muted,
    right && styles.right,
    className
  )

  React.useEffect(() => {
    const currentRef = textElementRef.current
    if (!currentRef) return
    setIsOverflowed(currentRef.scrollWidth > currentRef.clientWidth)
  }, [textElementRef])

  return (
    <td className={cellClassName} {...restProps}>
      <Tooltip
        className={cn(styles.cellContent, childIsString && styles.textContent)}
        content={children}
        disabled={!isOverflowed}
        ref={textElementRef}
      >
        {children}
      </Tooltip>
    </td>
  )
}
